import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=2fba4bb7&scoped=true&"
import script from "./Layout.vue?vue&type=script&lang=ts&"
export * from "./Layout.vue?vue&type=script&lang=ts&"
import style0 from "./Layout.vue?vue&type=style&index=0&id=2fba4bb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fba4bb7",
  null
  
)

export default component.exports